/*
  tabShow 是否展示底部导航
  keepAlive 是否需要缓存组件
  noLogin 页面是否开启免登录
*/

import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

import store from '@/store'
import { getToken, types, setToken } from '@/utils/Token'
import { Dialog, Toast } from 'vant'
import { judgeUserAgent } from '@/utils/judgeUserAgent'
import weChatpostMessage from '@/utils//weChatpostMessage.js'
import fetchData from './fetchData'

Vue.use(VueRouter)

const router = new VueRouter({
  // mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
// VueRouter.prototype.push = function push(location) {
// 	return originalPush.call(this, location).catch((err) => err)
// }

// VueRouter.prototype.replace = function replace(location) {
// 	return originalPush.call(this, location).catch((err) => err)
// }

const loginUrl = '/login'
const needAuth =
  process.env.VUE_APP_NEED_AUTH == 'true' ? true : false

// 获取当前用户的位置信息
async function getLocation() {
  if (store.getters.location.city === '') {
    await store
      .dispatch('location/getLocation')
      .catch(err => {
        console.log(err)
      })
    // return result
  }
}

const { getAuth } = weChatpostMessage()

function getMiniProgamAuth({ data = {}, routerTo = '' }) {
  // console.log(routerTo)
  const result = getAuth({ data, routerTo })
  // console.log(result, 66666);
  // setToken({
  //   Token: result.token,
  //   Refresh_token: result.refresh_token,
  //   Refresh_token_expiresat: result.refresh_token_expiresat,
  //   Expiresat: result.expiresat
  // })
}

// 小程序数据处理
const miniProgramDataHandle = data => {
  const datas = JSON.parse(decodeURIComponent(data))
  if (datas.action === 'getAuth') {
    setToken({
      Token: datas.data.token,
      Refresh_token: datas.data.refresh_token,
      Refresh_token_expiresat:
        datas.data.refresh_token_expiresat,
      Expiresat: datas.data.expiresat
    })
  }
}

window.addEventListener('popstate', function(event) {
  event.preventDefault()
  // 可以选择显示一个警告或者其他提示信息
  //  alert('无法返回上一页，继续操作！')
})

// 路由白名单
const passRoute = [
  '/login',
  '/UserInfoHandle',
  '/thirdPartLogin',
  '/exchange/home',
  '/other/jinKo/*',
  // '/other/jinKo/home'
]

const locationPass = ['/paymentCashier', '/payOrderStatus']

router.beforeEach(async (to, from, next) => {
  // 获取当前用户的位置信息

  // console.log(
  //   to.query?.miniprogram_data || from.query?.miniProgram_data
  // )

  // if (to.query?.miniprogram_data || from.query?.miniProgram_data ) {
  //     miniProgramDataHandle(to.query?.miniprogram_data || from.query?.miniProgram_data)
  //     next()
  // }
  const isPassRoute = passRoute.some(route => {
    if (route.includes('*')) {
      const baseRoute = route.replace('*', '')
      return to.path.startsWith(baseRoute)
    }
    return to.path === route
  })
  if (isPassRoute) {
    // if ( from.path === '/login' && to.path === '/UserInfoHandle') {
    next()
  } else {
    if (to.meta.noLogin && !needAuth) {
      next()
      // try {
      //   if (!locationPass.includes(to.path)) {
      //     await getLocation()
      //   }
      //     next()
      // } catch (err) {
      //   console.error('定位失败', err)
      //   next()
      // }
    } else {
      if (
        getToken(types.Token) &&
        getToken(types.Token) !== null
      ) {
        // 异步获取用户信息，不阻塞路由跳转
        fetchData(to, from).catch(err => {
          console.error('获取用户数据失败:', err)
        })
        next()

        // await getLocation().catch(err => {
        //   console.log(err)
        // })
        // if (to.meta.isGetUserSurplus) {
        //   store.dispatch('user/getUsersurplus')
        // }
        // if (Object.keys(store.getters.userInfo).length === 0) {
        //   await store.dispatch('user/getUserInfo')
        // }
      } else {
        // if (judgeUserAgent('miniProgram')) {
        // getAuth({ routerTo: to.fullPath })
        // const result = getMiniProgamAuth({
        //   routerTo: to.fullPath
        // })
        // } else {
        const fullPathString = encodeURIComponent(
          to.fullPath
        )
        if (to.path === loginUrl) {
          next()
        } else {
          if (needAuth) {
            // 需要登录并且带重定向参数
            next(`/login?redirect=${fullPathString}`)
            // next(`/login?${}`)
            Toast('请登录')
          } else {
            Dialog.confirm({
              title: '请先登录'
            }).then(() => {
              next(`/login?redirect=${fullPathString}`)
            })
          }
        }
      }
    }
  }
})

export default router
